import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["categorySelect", "subCategorySelect"]
  static values = {
    subId: Number
  }

  connect() {
    this.updateSubCategories();
  }

  async updateSubCategories() {
    const categoryId = this.categorySelectTarget.value;
    const addSubCategoryLink = document.getElementById("addSubCategory")

    if (!categoryId) {
      this.subCategorySelectTarget.innerHTML = '<option value="">Select SubCategory</option>';
      if (addSubCategoryLink) {
        addSubCategoryLink.style.display = "none";
      }
      return;
    }
    
    if (addSubCategoryLink) {
      addSubCategoryLink.style.display = "block";
    }

    const subCategoryForm = document.getElementById("subCategoryForm")
    if (subCategoryForm) {
      subCategoryForm.action = `/categories/${categoryId}/sub_categories`
    }

    const data = await this.fetchSubcategories(categoryId);

    if (data.sub_categories.length > 0) {
        if (window.location.href.includes("pos/listings")) {
          const options = data.sub_categories.map(subCategory => {
            const selected = subCategory[0] === this.subIdValue ? 'selected' : '';
            `<option value="${subCategory[0]}" ${selected}>${subCategory[1]}</option>`
          })
          this.subCategorySelectTarget.innerHTML = options
        } else if (window.location.href.includes("/new_listing") || (window.location.href.includes("/edit_listing"))) {
          const options = [
            '<option value="">Select Option</option>',
            ...data.sub_categories.map(subCategory => {
              const selected = subCategory[0] === this.subIdValue ? 'selected' : '';
              return `<option value="${subCategory[0]}" ${selected}>${subCategory[1]}</option>`;
            })
          ].join('');
        this.subCategorySelectTarget.innerHTML = options
        } else {
          const options = [
              '<option value="">All SubCategories</option>',
              ...data.sub_categories.map(subCategory => 
                  `<option value="${subCategory[0]}">${subCategory[1]}</option>`
                )
          ].join('');
          this.subCategorySelectTarget.innerHTML = options
        }
    } else {
        this.subCategorySelectTarget.innerHTML = '<option value="">No SubCategories found</option>'
    }
  }

  async fetchSubcategories(categoryId) {
    const subId = this.subIdValue
    const response = await fetch(`/categories/${categoryId}/sub_categories?selected_sub_value=${subId}`);
    return response.json();
  }
}
